// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M17 0H3a1 1 0 00-1 1v18a1 1 0 001 1h14a1 1 0 001-1V1a1 1 0 00-1-1zM4 18h12V2H4v16zM9 6h2a1 1 0 100-2H9a1 1 0 100 2m1 8a1 1 0 100 2 1 1 0 000-2\"/></svg>";
// Exports
module.exports = code;